
import Vue from 'vue'

import { getRequest } from '@/plugins/api-axios'
import { deserialise } from 'kitsu-core'
import lodash from 'lodash'
export default Vue.extend({
    components: {},

    props: {
        value: {
            type: Object,
            default: null,
        },
        filters: {
            type: Object,
            default: null,
        },
        module: {
            type: String,
            default: 'authorization',
        },
        endpoint: {
            type: String,
            default: 'projectUsers',
        },
        include: {
            type: Array,
            default: () => ['user.employer'],
        },
    },

    data() {
        return {
            isDirty: false,
            loading: false,
            searchTerm: '',
            limit: 10,
            offset: 0,
            infiniteID: new Date(),
            users: [] as Array<any>,
            attachmentUrl: process.env.VUE_APP_ATTACHMENT_BASE_URL,
        }
    },

    computed: {},

    methods: {
        getUserInitials(user) {
            let initials: string | null = null
            if (user.name) {
                let names = user.name.split(' ')
                initials = names[0]?.split('')[0] + names.pop()?.split('')[0]
            } else if (user.pendingDisplayName) {
                let names = user.pendingDisplayName.split(' ')
                initials = names[0]?.split('')[0] + names.pop()?.split('')[0]
            }

            return initials
        },

        async loadMore($state) {
            this.loading = true
            let res = await this.searchUsers()

            this.users = [...this.users, ...res]

            if (res.length == this.limit) {
                $state.loaded()
            } else {
                $state.complete()
            }
            this.loading = false
        },

        async searchUsers() {
            try {
                let res = await getRequest(
                    `https://${this.module}.${process.env.VUE_APP_VBIT_API}/${this.endpoint}`,
                    { 'Content-Type': 'application/vnd.api+json' },
                    {
                        include: this.include.join(','),
                        ...(this.endpoint == 'users' && { 'filter[kind]': 'normal' }),
                        ...(this.endpoint == 'projectUsers' && {
                            'filter[userKindIfConfirmed]': 'normal',
                        }),
                        ...this.filters,
                        ...(this.searchTerm &&
                            this.searchTerm.length > 2 && {
                                'filter[searchTerm]': this.searchTerm,
                            }),
                        'page[offset]': this.offset,
                        'page[limit]': this.limit,
                        'filter[project]': this.currentProjectId,
                    }
                )

                let users = deserialise(res.data).data
                this.offset = this.offset + users.length

                return users
            } finally {
                this.loading = false
            }
        },

        load: lodash.debounce(async function (this) {
            if (this.isDirty) {
                this.loading = true
                this.offset = 0
                if (this.value && !this.searchTerm) {
                    this.users = [this.value]
                } else {
                    this.users = []
                }
                this.infiniteID = new Date()
                this.loading = false
            }
        }, 500),
    },
    watch: {
        isDirty: {
            immediate: false,
            handler() {
                this.load()
            },
        },
        searchTerm: {
            immediate: false,
            handler() {
                if (this.isDirty) {
                    this.loading = true
                }
                this.load()
            },
        },
    },

    mounted() {
        if (this.value) {
            this.users = [this.value]
        }
    },
})
